_collow.components.ProfilePicture = class ProfilePicture extends _collow.components.Base {
  root;
  elements;
  params;

  constructor (root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    this._loadImageFromLocalStorage();
  }

  _loadImageFromLocalStorage () {
    const progressJson = window.localStorage.getProgressJson();
    this.updateImagePreview(progressJson?.profile_picture?.file_url);
  }

  updateImagePreview(imagePath) {
    this.elements.image.setAttribute('data-image:path', imagePath);
    this.elements.defaultimage[imagePath ? 'setAttribute' : 'removeAttribute']('hidden', '');
    this.elements.image[imagePath ? 'removeAttribute' : 'setAttribute']('hidden', '');
    if (imagePath) _collow.components.Image.fromElement(this.elements.image).getImages();
  }
}
